import { render, staticRenderFns } from "./UpdateMail.vue?vue&type=template&id=64826570&scoped=true"
import script from "./UpdateMail.vue?vue&type=script&lang=js"
export * from "./UpdateMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64826570",
  null
  
)

export default component.exports